export const link = [
    {
        id: 1,
        name: "Քիմիայի առարկայի 7–12 դասարանների չափորոշիչ",
        info: "https://www.arlis.am/hy/acts/53592",
        menuItemId: 4
    },
    {
        id: 2,
        name: "Քիմիայի առարկայի 8 և 11 դասարանների ծրագիր",
        info: "https://www.arlis.am/hy/acts/53561",
        menuItemId: 4
    },
    {
        id: 3,
        name: "Քիմիայի առարկայի 9 և 12 դասարանների ծրագիր",
        info: "https://www.irtek.am/views/act.aspx?aid=158038",
        menuItemId: 4
    },
    {
        id: 4,
        name: "Իրազեկում. «Քիմիա»",
        info: "https://www.facebook.com/story.php?story_fbid=2953231728237435&id=1835465163347436",
        menuItemId: 4
    },


];
